module.exports = __webpack_public_path__ + "img/logo@3x.db1a3a9.8d08ecf2.png";